import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "c-form-search-candidate flex flex-col self-start w-full" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "home__banner-content-action_subtitle text-base text-left mb-4" }, " Primeiro, selecione o(s) seguinte(s) campo(s) ", -1)
const _hoisted_3 = { class: "grid grid-cols-2 gap-2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Cargo", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("option", {
  selected: "",
  disabled: "",
  value: ""
}, "Cargo", -1)
const _hoisted_6 = ["value"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Localidade", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("option", {
  selected: "",
  disabled: "",
  value: ""
}, "Localidade", -1)
const _hoisted_9 = ["value"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h3", { class: "home__banner-content-action_subtitle text-base text-left my-3" }, " Tem uma pessoa candidata em mente? ", -1)
const _hoisted_11 = { class: "home__banner-content-action_form sm:flex flex-grow animate__animated animate__fadeIn" }
const _hoisted_12 = { class: "flex-auto mr-2" }
const _hoisted_13 = { class: "relative block" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Digite o nome da pessoa candidata", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "absolute inset-y-0 left-0 flex items-center pl-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined" }, "search")
], -1)
const _hoisted_16 = {
  key: 0,
  class: "block"
}
const _hoisted_17 = { class: "list-search inline-block absolute z-10 box-content py-2 px-3 text-sm tooltip font-medium text-white bg-primary-dark rounded-lg shadow-sm" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "w-full capitalize" }
const _hoisted_20 = {
  key: 0,
  class: "px-2 py-3"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", null, "Não encontramos resultados para sua pesquisa!", -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("h3", { class: "home__banner_subtitle text-left mt-6 mb-3" }, " Não tem alguém em mente? ", -1)
const _hoisted_24 = { class: "sm:flex block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", null, [
      _createElementVNode("form", _hoisted_3, [
        _createElementVNode("div", {
          class: _normalizeClass(!_ctx.location ? 'col-span-2' : '')
        }, [
          _hoisted_4,
          _withDirectives(_createElementVNode("select", {
            id: "roleCandidates",
            name: "roleCandidates",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.roleCandidates) = $event)),
            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.hasLocation && _ctx.hasLocation(...args))),
            class: "bg-background-purpleLight py-3 px-5 text-white text-sm rounded-full font-regular focus:ring-secondary-base focus:border-secondary-base block w-full",
            placeholder: "Cargo",
            required: ""
          }, [
            _hoisted_5,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.roles, (role) => {
              return (_openBlock(), _createElementBlock("option", {
                key: role.id,
                value: role.id
              }, _toDisplayString(!role ? "Não foi possível carregar as informações" : role.name), 9, _hoisted_6))
            }), 128))
          ], 544), [
            [_vModelSelect, _ctx.roleCandidates]
          ])
        ], 2),
        (_ctx.location)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(
            _ctx.location
              ? 'animate__animated animate__fadeInRight'
              : 'animate__animated animate__fadeOutRight'
          )
            }, [
              _hoisted_7,
              _withDirectives(_createElementVNode("select", {
                id: "localeCandidates",
                name: "localeCandidates",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localeCandidates) = $event)),
                class: "bg-background-purpleLight py-3 px-5 text-white text-sm rounded-full font-regular focus:ring-secondary-base focus:border-secondary-base block w-full",
                required: "",
                placeholder: "Localidade"
              }, [
                _hoisted_8,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.locales, (locale) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: locale.initials,
                    value: locale.initials
                  }, _toDisplayString(locale.name), 9, _hoisted_9))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.localeCandidates]
              ])
            ], 2))
          : _createCommentVNode("", true)
      ])
    ]),
    (
        (_ctx.roleCandidates && _ctx.localeCandidates) || (_ctx.roleCandidates && !_ctx.location)
      )
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(
        (_ctx.roleCandidates && _ctx.localeCandidates) || (_ctx.roleCandidates && !_ctx.location)
          ? 'mt-10 animate__animated animate__fadeIn'
          : 'hidden'
      )
        }, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("label", _hoisted_13, [
                _hoisted_14,
                _hoisted_15,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "first_name",
                  autocomplete: "off",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchListCandidates.name) = $event)),
                  onInput: _cache[4] || (_cache[4] = ($event: any) => (
                _ctx.searchListCandidates.name.length > 1
                  ? (_ctx.showListCandidates = true)
                  : (_ctx.showListCandidates = false)
              )),
                  class: "bg-background-purpleLight text-white text-sm rounded-full font-regular placeholder:text-white placeholder-white focus:ring-secondary-base focus:border-secondary-base focus:bg-background-purpleLight block w-full py-3 pl-10 pr-5",
                  placeholder: "Digite o nome da pessoa candidata",
                  required: ""
                }, null, 544), [
                  [_vModelText, _ctx.searchListCandidates.name]
                ])
              ]),
              (_ctx.showListCandidates)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createElementVNode("ul", _hoisted_17, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredList.slice(0, 4), (candidate) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: candidate.id,
                          class: "w-full cursor-pointer px-2 py-3 border-b border-primary-base",
                          onClick: ($event: any) => (
                  (_ctx.searchListCandidates.name = candidate.name),
                    (_ctx.searchListCandidates.id = candidate.id),
                    (_ctx.showListCandidates = false)
                )
                        }, [
                          _createElementVNode("span", _hoisted_19, _toDisplayString(candidate.name), 1)
                        ], 8, _hoisted_18))
                      }), 128)),
                      (_ctx.searchListCandidates && !_ctx.filteredList.length)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_20, _hoisted_22))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "flex-none text-primary-base sm:w-auto sm:mt-0 xs:block w-full mt-4 uppercase font-bold bg-secondary-base font-medium rounded-full text-sm px-5 py-3 text-center mr-2 mb-2",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleSearchCandidate(_ctx.searchListCandidates.id)))
            }, " Buscar ")
          ]),
          _hoisted_23,
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("button", {
              type: "submit",
              class: "flex-none mt-0 xs:block w-full text-primary-base uppercase font-bold bg-secondary-base hover:bg-secondary-light focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded-full text-sm px-5 py-3 text-center mr-2 mb-2",
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleSubmitCompareCandidates && _ctx.handleSubmitCompareCandidates(...args)))
            }, " Comparar candidaturas ")
          ])
        ], 2))
      : _createCommentVNode("", true)
  ]))
}